// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createpassword-container {
  display: flex;
  justify-content: center;
  align-items: center;

  padding-top: 50px;
}

.create-password-h {
  color: #000;
  font-family: "Montserrat";
  font-size: var(--Font-Font-Size-h2, 33px);
  font-style: normal;
  font-weight: 800;
  text-align: center;
  line-height: 30px;
}
.create-password-sh {
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.validation-container {
  display: flex;
  width: 90%;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: #f5f5f5;
}
.validation-container-text {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
}

.reset-new-button {
  width: 90%;
  margin-left: 27px;
  background-color: #d2042d;
  border: none;
  margin-top: 20px;
  font-weight: bold;
  height: 50px;
}
.billboard-input-field,
.reset-password-fields {
  width: 100%;
}
.restrictions-row {
  width: 100%;
}
.change-password-container {
  height: 91.3vh !important;
  width: 100% !important;
}
@media only screen and (max-width: 1024px) {
  .createpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;

    padding-top: 100px;
  }
  .create-password-h {
    color: #000;
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h2, 25px);
    font-style: normal;
    font-weight: 800;

    line-height: 30px;
  }
  .create-password-sh {
    color: #666;
    text-align: center;
    /* leading-trim: both;
        text-edge: cap; */
    font-family: Roboto;
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
  .validation-container {
    display: flex;
    width: 90%;
    padding: 7px;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: #f5f5f5;
    color: #000;
    margin-left: 0px !important;
  }
  .validation-container-text {
    color: #000;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-small, 13px);
    font-style: normal;
    font-weight: 400;
    line-height: 18.2px;
  }
  .reset-new-button {
    margin-top: 3rem;
    width: 375px !important;
    margin-left: 0px !important;
  }
}

@media only screen and (max-width: 768px) {
  .create-new-password-main-space {
    margin-top: 7% !important;
  }
  .createpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px;
    padding-top: 100px;
  }
  .create-password-h {
    color: #000;
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h2, 25px);
    font-style: normal;
    font-weight: 800;

    line-height: 30px;
  }
  .create-password-sh {
    color: #666;
    text-align: center;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-p, 13px);
    font-style: normal;

    font-weight: 500;
    line-height: 24px; /* 150% */
  }
  .validation-container {
    display: flex;
    width: 90% !important;
    padding: 10px;
    justify-content: center;
    align-items: center;
    margin-left: 3px !important;
    border-radius: 5px;
    background: #f5f5f5;
    color: #000;
  }
  .validation-container-text {
    color: #000;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-small, 13px);
    font-style: normal;
    font-weight: 400;
    line-height: 18.2px;
  }
  .reset-new-button {
    margin-top: 2rem;
    width: 90% !important;
    margin-left: 5px !important;
    height: 40px !important;
  }
}
@media only screen and (max-width: 425px) {
  .createpassword-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 25px;
  }
}
@media only screen and (max-width: 375px) {
  .create-password-h {
    color: #000;
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h2, 21px);
    font-style: normal;
    font-weight: 800;

    line-height: 30px;
  }

  .create-password-sh {
    color: #666;
    text-align: center;
    font-family: Roboto;
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/LoginPage/createnewpassword/CreateNewPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB;yBACqB;IACrB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;EACA;IACE,aAAa;IACb,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;;IAElB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;EACA;IACE,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;EACzB;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;IACX,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".createpassword-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding-top: 50px;\n}\n\n.create-password-h {\n  color: #000;\n  font-family: \"Montserrat\";\n  font-size: var(--Font-Font-Size-h2, 33px);\n  font-style: normal;\n  font-weight: 800;\n  text-align: center;\n  line-height: 30px;\n}\n.create-password-sh {\n  color: #666;\n  text-align: center;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.validation-container {\n  display: flex;\n  width: 90%;\n  padding: 12px;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  background: #f5f5f5;\n}\n.validation-container-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18.2px;\n}\n\n.reset-new-button {\n  width: 90%;\n  margin-left: 27px;\n  background-color: #d2042d;\n  border: none;\n  margin-top: 20px;\n  font-weight: bold;\n  height: 50px;\n}\n.billboard-input-field,\n.reset-password-fields {\n  width: 100%;\n}\n.restrictions-row {\n  width: 100%;\n}\n.change-password-container {\n  height: 91.3vh !important;\n  width: 100% !important;\n}\n@media only screen and (max-width: 1024px) {\n  .createpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    padding-top: 100px;\n  }\n  .create-password-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h2, 25px);\n    font-style: normal;\n    font-weight: 800;\n\n    line-height: 30px;\n  }\n  .create-password-sh {\n    color: #666;\n    text-align: center;\n    /* leading-trim: both;\n        text-edge: cap; */\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 150% */\n  }\n  .validation-container {\n    display: flex;\n    width: 90%;\n    padding: 7px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n    background: #f5f5f5;\n    color: #000;\n    margin-left: 0px !important;\n  }\n  .validation-container-text {\n    color: #000;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18.2px;\n  }\n  .reset-new-button {\n    margin-top: 3rem;\n    width: 375px !important;\n    margin-left: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .create-new-password-main-space {\n    margin-top: 7% !important;\n  }\n  .createpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 350px;\n    padding-top: 100px;\n  }\n  .create-password-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h2, 25px);\n    font-style: normal;\n    font-weight: 800;\n\n    line-height: 30px;\n  }\n  .create-password-sh {\n    color: #666;\n    text-align: center;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-p, 13px);\n    font-style: normal;\n\n    font-weight: 500;\n    line-height: 24px; /* 150% */\n  }\n  .validation-container {\n    display: flex;\n    width: 90% !important;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    margin-left: 3px !important;\n    border-radius: 5px;\n    background: #f5f5f5;\n    color: #000;\n  }\n  .validation-container-text {\n    color: #000;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18.2px;\n  }\n  .reset-new-button {\n    margin-top: 2rem;\n    width: 90% !important;\n    margin-left: 5px !important;\n    height: 40px !important;\n  }\n}\n@media only screen and (max-width: 425px) {\n  .createpassword-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 25px;\n  }\n}\n@media only screen and (max-width: 375px) {\n  .create-password-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h2, 21px);\n    font-style: normal;\n    font-weight: 800;\n\n    line-height: 30px;\n  }\n\n  .create-password-sh {\n    color: #666;\n    text-align: center;\n    font-family: Roboto;\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
